var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"surround"},[_c('div',{staticClass:"box"},[_c('icon',{attrs:{"type":"loader","animation":"spin","size":"36"}}),_c('div',{staticClass:"text"},[_vm._v("\n      Načítání…\n    ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }